import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './lib/offline';
import './i18n';
import './styles/index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Cache de l'application et du contenu deja consulte : la plateforme reste
// utilisable sur une connexion lente ou interrompue.
registerServiceWorker();
